module.exports = __webpack_public_path__ + "img/amazon-icon.2dd42290.svg";